export const environment = {
  production: true,
  env: 'Production',
  ApiUrl: 'https://h2hapi.clavisco.com/',  //revisar URL
};
